import React, { useState, useReducer, useContext, useEffect } from "react";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { reducer } from "Modules";
import { Heading, Body } from "Routes/Root/Register";
import { firebase, EventContext, UserContext, AnalyticsContext } from "context";
import { ButtonPrimary } from "Components/Buttons";
import { handleErrors, Field } from "Components/Form";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useLocation, useParams } from "react-router-dom";

export const RegistrationForm = ({
  formPart,
  formHeading,
  formLegal,
  submitButton,
  setIneligible,
  setLoading,
}) => {
  const { event } = useContext(EventContext);
  const { language } = useParams();

  // const [eventLanguage, loading, error] = useDocumentData(
  //   firebase.firestore().doc(`events/${event?.id}/languages/${language}`)
  // );

  const { writeToUserSubmissionDoc } = useContext(UserContext);
  const { logLeadSubmission, logClick } = useContext(AnalyticsContext);

  const [registration, setRegistration] = useReducer(reducer, {});
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const { heading, body } = event?.register || {};
  const { fields } = event?.register || event?.register;

  const linkClickHandler = (url, label, category) => {
    logClick({ label, url }, category);
  };

  const handleChange = (value, name) => {
    setRegistration(value);
    delete errors[name];
    setErrors(errors);
  };

  useEffect(() => {
    setSubmitting(false);
  }, [submitButton]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorObject = handleErrors(fields, registration, formPart);

    if (!errorObject) {
      setSubmitting(true);

      registration.formPart = formPart;
      // registration.LANG = language;
      await writeToUserSubmissionDoc(registration);
      logLeadSubmission({ formPart, registration });
    } else {
      setSubmitting(false);
      setErrors(errorObject);
    }
  };

  return (
    <>
      {fields && (
        <RegForm onSubmit={handleSubmit}>
          {heading && <Heading>{ReactHtmlParser(heading)}</Heading>}
          {body && <Body>{ReactHtmlParser(body)}</Body>}
          <Form>
            {fields
              .sort((a, b) => a.order - b.order)
              .filter((field) => {
                return field.formPart === formPart;
              })
              .map((field, index) => {
                let mobileSize = "100%";
                let desktopSize = "97%";
                if (field.span === "half") desktopSize = "calc(48% - 4px)";

                if (
                  field.span !== "full" &&
                  (field.spanMobile === "half" || !field.spanMobile)
                )
                  mobileSize = "calc(48% - 4px)";

                return (
                  <FieldContainer
                    sizeDesktop={desktopSize}
                    sizeMobile={mobileSize}
                    fullSize={field.span === "full"}
                    key={index}
                    order={field.order}
                  >
                    {field.type === "radio" && formHeading && (
                      <FormTitle>{ReactHtmlParser(formHeading)}</FormTitle>
                    )}
                    {/* {field.type !== "optIn" && !!field.label && (
                        <Label>{field.label}</Label>
                      )} */}

                    <Field
                      field={field}
                      value={registration[field.name]}
                      onChange={(value) => handleChange(value, field.name)}
                      error={{
                        status: errors[field.name],
                        message: errors[field.name]?.message,
                      }}
                    />
                  </FieldContainer>
                );
              })}

            {formLegal && (
              <FormLegal
                onClick={() =>
                  linkClickHandler(
                    "https://bit.ly/3NcIkPn",
                    "Sweepstakes Rules",
                    "internal"
                  )
                }
              >
                {ReactHtmlParser(formLegal)}
              </FormLegal>
            )}
          </Form>

          {submitting ? (
            <RegisterButton>Loading</RegisterButton>
          ) : (
            <RegisterButton
              type="submit"
              onClick={() =>
                linkClickHandler("Register button", "Registration", "internal")
              }
            >
              {submitButton ? submitButton : "Submit"}
            </RegisterButton>
          )}
        </RegForm>
      )}
    </>
  );
};

const FormTitle = styled.p`
  margin: 12px 0;
  color: #000;
  font-size: 25px;
  font-family: "Avenir_Bold";
`;

const Form = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 10px;
  row-gap: 20px;
  margin: 20px 0px;
  width: 100%;
  max-width: 700px;

  @media (max-width: 500px) {
    gap: 25px;
    row-gap: 25px;
  }
  /* @media (max-width: 950px) {
    padding: 10px auto 320px;
  } */
`;

const RegForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-top: -20px;
  @media (max-width: 950px) {
    margin-top: -60px;
    margin-bottom: -30px;
    padding: 10px 10px 30px;
  }
`;

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 ${(props) => props.sizeMobile};
  ${(props) => props.order && `order: ${props.order};`}
  width: 100%;

  @media ${(props) => props.theme.maxMedia.medium} {
    flex: 0 1 ${(props) => props.sizeDesktop};
  }
`;

const Label = styled.span`
  color: #092a49;
  font-size: 14px;
  margin-bottom: 5px;
`;

const FormLegal = styled.div`
  font-size: 11px;
  margin: 10px 10px 15px 25px;
  order: 99;
  color: #092a49;

  a,
  a:visited {
    color: #092a49;
  }
`;

const RegisterButton = styled(ButtonPrimary)`
  width: 35%;
  @media (max-width: 950px) {
    margin: 25px 0 25px 0;
    width: 90%;
    padding: 10px 0;
    font-size: 0.85rem;
    align-self: center;
  }
`;
